// extracted by mini-css-extract-plugin
export default {"root":"_17ETb","small":"_2tzpv","normal":"_1Ett3"};